/**
 * Skill ARIs read back from chat history, keyed by action invocation id.
 *
 * A custom skill card is remounted while it stays on screen — sending another message recreates the
 * message subtree — so an ARI held only in component state is lost and the card falls back from Edit
 * to Confirm. This cache lets the next mount seed itself on its first render.
 */
const resolvedSkillAris = new Map<string, string>();

export const getResolvedSkillAri = (invocationId: string | undefined): string | undefined =>
	invocationId === undefined ? undefined : resolvedSkillAris.get(invocationId);

export const cacheResolvedSkillAri = (invocationId: string, skillAri: string): void => {
	resolvedSkillAris.set(invocationId, skillAri);
};

export const forgetResolvedSkillAri = (invocationId: string): void => {
	resolvedSkillAris.delete(invocationId);
};

/** Test-only: the cache outlives a render tree, so tests sharing invocation ids must reset it. */
export const clearResolvedSkillAris = (): void => {
	resolvedSkillAris.clear();
};
